import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoggedInUser, QuizQuestion } from 'src/app/models';
import { AuthService } from 'src/app/services/auth.service';
import { CoursesService } from 'src/app/services/courses.service';
import { QuizService } from 'src/app/services/quiz.service';

@Component({
  selector: 'app-module10-fhe',
  templateUrl: './module10-fhe.component.html',
  styleUrls: ['./module10-fhe.component.css', '../fair-housing-education.component.css']
})
export class Module10FheComponent implements OnInit, OnDestroy {

  user!: LoggedInUser;

  // Last module, determines whether to show course complete or the module
  courseComplete = false;

  // Contains all questions for the module
  questions: QuizQuestion[] = [];


  // Determine if quiz has started
  quizStart: boolean = false;

  constructor(private courseService: CoursesService, private quizService: QuizService, private auth: AuthService, private router: Router) { }

  ngOnInit(): void {
    this.courseService.setCurrentCourseBy('Fair Housing Education');

    this.user = this.auth.user || {};

    // Get the questions for this module and assign them to this.questions
    this.quizService.getModuleQuizzes("61f359080a0a3525d8d3c938").toPromise().then((res: any) => {
      this.quizService.moduleQuizQuestions = res.docs;
      this.questions = this.quizService.moduleQuizQuestions;
    });
  }

  // Reset
  ngOnDestroy(): void {
    this.courseComplete = false;
  }

  // Update furthestModuleID
  updateProgress() {
    if (this.courseService.currentCourse.furthestModuleID < 10) {
      this.courseService.updateFurthestModule().toPromise();
    }

    // Course is complete
    if (this.courseService.currentCourse.furthestModuleID == 10) {
      this.courseComplete = true;
      this.courseService.markAsCompleted().toPromise();
    }
  }

  // Start quiz
  startQuiz(event?: Event) {
    if (event?.defaultPrevented) return false;

    this.quizStart = true;

    // Scroll to top
    window.scrollTo(0, 0);

    return true;
  }

  // Handle the quiz results, allow them to pass or not
  handleQuiz(valueEmitted: boolean){

    // Quiz passed
    if (valueEmitted) {
      this.updateProgress();
    }

    // Review
    else {
      this.quizStart = false;
    }
  }
}
